interface State {
    provinces: string[]
}

const defaults = () => {
    return {
        provinces: [
            "AB",
            "BC",
            "MB",
            "NB",
            "NL",
            "NS",
            "ON",
            "PE",
            "QC",
            "SK"
        ]
    }
}

export default {
    state: defaults(),
    mutations: {
        provincesReset (state: State): void {
            Object.assign(state, defaults())
        },
        provincesSet (state: State, provinces: string[]): void {
            state.provinces = provinces
        },
    },
    actions: {},
    getters: {
        provinces (state: State): string[] {
            return state.provinces
        }
    }
}
